module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bulb1-2a9f3111c830c6172d232e1a4f1716d2.svg";